module.exports = __webpack_public_path__ + "static/media/final_rendering_for_hunter_banks_mural_2011.b85a8a42.webp";